const initialState = {
  flags: [],
  errors: {},
};

const flags = (state = initialState, { type, payload }) => {
  switch (type) {
    case 'FLAGS_RESOURCE_SUCCESS':
      return {
        ...state,
        flags: payload.flag_options,
      };
    case 'FLAGS_RESOURCE_FAILURE':
      return {
        ...state,
        errors: payload.errors,
      };
    default:
      return state;
  }
};

export default flags;

const getFlags = state => state.flags;
export { getFlags };




// WEBPACK FOOTER //
// ./client/app/reducers/flags.js